import DefaultConfig from "../DefaultConfig";
import { VUE_APP_UI_URL } from "../../environment";
import { getLoginRouteForTimeout } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default class Service {
  // Will be used by this service for making API calls
  axiosIns = null;

  // Config <= Will be used by this service
  Config = { ...DefaultConfig };

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // For Refreshing Token
  subscribers = [];

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns;
    this.Config = { ...this.Config, ...jwtOverrideConfig };

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      (config) => {
        const accessToken = this.getToken();
        if (accessToken) {
          config.headers.Authorization = `${this.Config.tokenType} ${accessToken}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      (response) => {
        console.log("interceptors.response.use - on response");
        if (response.status === 401) {
          // unauthorized
          let path = pURL.parse(response.config.url).path;
          const inApi = new String(path).split("/")[1];
          if (inApi === "api") {
            console.log("Unauthorized API access: " + path);
          }
        }

        return response;
      },
      (error) => {
        console.log("interceptors.response.use - on error");
        try {
          if (error.response.status == 401 || error.response.status == 403) {
            this.$router.replace(getLoginRouteForTimeout()).then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "เซสชั่นหมดอายุ",
                  icon: "AlertCircleIcon",
                  variant: "warning",
                  text: "กรุณาเข้าสู่ระบบอีกครั้ง",
                },
              });
            });
          }
        } catch (error) {
          localStorage.clear();
          //router.push("/login");
          window.location.href = VUE_APP_UI_URL + "/login";
        }

        /** Do something with response error */
        /*if (error.response.status == 401 || error.response.status == 403) {
          this.$router.replace(getLoginRouteForTimeout()).then(() => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "เซสชั่นหมดอายุ",
                icon: "AlertCircleIcon",
                variant: "warning",
                text: "กรุณาเข้าสู่ระบบอีกครั้ง",
              },
            });
          });
        }*/
        return Promise.reject(error);
      }
    );
  }

  getToken() {
    return localStorage.getItem(this.Config.storageTokenKeyName);
  }

  getRefreshToken() {
    return localStorage.getItem(this.Config.storageRefreshTokenKeyName);
  }

  //

  getRequestReport(...args) {
    return this.axiosIns.post(this.Config.reportRequest, ...args);
  }

  getRequestDeptReport(...args) {
    return this.axiosIns.post(this.Config.reportDeptRequest, ...args);
  }

  getRequestDeliveredFile(...args) {
    return this.axiosIns.post(this.Config.getRequestDeliveredFile, ...args);
  }

  getRequestActionLog(...args) {
    return this.axiosIns.post(this.Config.getRequestActionLog, ...args);
  }
  
  //

  getSearchRequest(...args) {
    return this.axiosIns.post(this.Config.searchRequest, ...args);
  }

  getFormRequest(...args) {
    return this.axiosIns.post(this.Config.formRequest, ...args);
  }

  getFormRequestByJobNo(...args) {
    return this.axiosIns.post(this.Config.formRequestByJobNo, ...args);
  } 

  getDestLocationRequestByJobNo(...args) {
    return this.axiosIns.post(this.Config.destLocationByIdAndJobNo, ...args);
  } 

  saveRequest(...args) {
    return this.axiosIns.post(this.Config.saveRequest, ...args);
  }

  getCustomerLocation(...args) {
    return this.axiosIns.post(this.Config.loadCustomerLocation, ...args);
  }

  getCustomerContact(...args) {
    return this.axiosIns.post(this.Config.loadCustomerContact, ...args);
  }

  saveCustomerLocation(...args) {
    return this.axiosIns.post(this.Config.saveCustomerLocation, ...args);
  }

  saveCustomerContact(...args) {
    return this.axiosIns.post(this.Config.saveCustomerContact, ...args);
  }
  
  getResponseDeleteRequest(...args) {
    return this.axiosIns.post(this.Config.deleteRequest, ...args);
  }

  getResponseAcceptAndReturnRequest(...args) {
    return this.axiosIns.post(this.Config.acceptRequest, ...args);
  } 

  getResponseChangeRequest(...args) {
    return this.axiosIns.post(this.Config.changeRequest, ...args);
  } 

  getResponseEditByAdmin(...args) {
    return this.axiosIns.post(this.Config.editRequestByAdmin, ...args);
  } 

  saveDeliverRequest(...args) {
    return this.axiosIns.post(this.Config.deliverRequest, ...args);
  } 
  
  //

  getSearchDepartment(...args) {
    return this.axiosIns.post(this.Config.searchDepartment, ...args);
  }

  saveDepartment(...args) {
    return this.axiosIns.post(this.Config.saveDepartment, ...args);
  }

  getResponseDeleteDepartment(...args) {
    return this.axiosIns.post(this.Config.deleteDepartment, ...args);
  }

}
